import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import "../../../utils/quiz-parser.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizProblem, PrintQuizImage, PrintInputBox, getStyles } from "./print-common.js";
function BooleanPrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  var _a, _b, _c;
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const correctIsTrue = (correctAnswers == null ? void 0 : correctAnswers[0]) != null ? correctAnswers[0] === "true" : ((_c = (_b = (_a = quiz.pairs) == null ? void 0 : _a.left) == null ? void 0 : _b[0]) == null ? void 0 : _c.key) === "true";
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    /* @__PURE__ */ jsx(
      PrintQuizProblem,
      {
        problem: quiz.problem,
        quizId,
        additionalImages: quiz.additionalImages,
        compact
      }
    ),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-[20px] w-full", children: [
      /* @__PURE__ */ jsx(
        PrintInputBox,
        {
          size: "md",
          compact,
          className: cn(
            showCorrectAnswers && correctIsTrue ? "border-[#e50000] border-2" : ""
          ),
          children: /* @__PURE__ */ jsx("svg", { width: "28", height: "28", viewBox: "0 0 28 28", fill: "none", children: /* @__PURE__ */ jsx(
            "circle",
            {
              cx: "14",
              cy: "14",
              r: "10",
              stroke: showCorrectAnswers && correctIsTrue ? "#e50000" : "#00AAFF",
              strokeWidth: "4",
              fill: "none"
            }
          ) })
        }
      ),
      /* @__PURE__ */ jsx(
        PrintInputBox,
        {
          size: "md",
          compact,
          className: cn(
            showCorrectAnswers && !correctIsTrue ? "border-[#e50000] border-2" : ""
          ),
          children: /* @__PURE__ */ jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ jsx("path", { d: "M4 4L20 20M20 4L4 20", stroke: "#E50000", strokeWidth: "4", strokeLinecap: "round" }) })
        }
      )
    ] })
  ] });
}
export {
  BooleanPrint
};
//# sourceMappingURL=boolean-print.js.map
